/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { Icon } from 'sarsaparilla';

export default class TripFiltersSteps extends React.Component {
    render() {
        return (
            <ul className="trip-planner-steps">
                <li>
                    <span className="trip-planner-icon-wrap">
                        <Icon iconName="calendar" />
                    </span>
                    <span className="h6">Add your dates</span>
                </li>
                <li className="trip-planner-steps-arrow">
                    <Icon iconName="arrow-forward" />
                </li>
                <li>
                    <span className="trip-planner-icon-wrap">
                        <Icon iconName="pin-drop" />
                    </span>
                    <span className="h6">Add destinations</span>
                </li>
                <li className="trip-planner-steps-arrow">
                    <Icon iconName="arrow-forward" />
                </li>
                <li>
                    <span className="trip-planner-icon-wrap">
                        <Icon iconName="map" />
                    </span>
                    <span className="h6">Start building</span>
                </li>
                <li className="trip-planner-steps-arrow">
                    <Icon iconName="arrow-forward" />
                </li>
                <li>
                    <span className="trip-planner-icon-wrap">
                        <Icon iconName="check" />
                    </span>
                    <span className="h6">Book it</span>
                </li>
            </ul>
        );
    }
}
